import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  li: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'auto',
    marginLeft: 10,
    padding: 2,
    background: '#F0F3F7',
    borderRadius: '50%',
  },
  leveler: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
  name: {
    fontSize: 14,
  },
  size: {
    fontSize: 13,
  },
  icon: {
    fontSize: '1.1rem',
    color: theme.custom.darkBlue,
    borderRadius: '50%',
  },
}));
